/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';

export const Dropdown = (props) => {
  const [value, setValue] = React.useState(['']);
  const [radioValue, setRadioValue] = useState('');
  const [drpRequired, setDrpRequired] = useState(true);
  const [radioRequired, setRadioRequired] = useState(true);
  const [question] = useState(props);
  question?.qstn?.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });

  const options: any = [];

  question?.qstn?.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });
  question?.qstn?.options[0].values.forEach((val) => {
    options.push({ value: val.value, label: val.value });
  });

  const [focusOnTextBox, setFocusOnTextBox] = useState(false);

  const optionValuesArray: string[] = [];
  question?.qstn?.options.map((opt, i) => {
    return optionValuesArray.push(opt.values[0].value);
  });
  useEffect(() => {
    // console.log(value);
    // console.log(radioValue);
    if (value.length > 0) {
      setRadioValue('');
      setRadioRequired(false);
    }
  }, [value]);
  useEffect(() => {
    // console.log(radioValue);
    // console.log(question?.qstn.options[2].values[0].value);
    if (radioValue.trim() === question?.qstn.options[1].values[0].value) {
      setDrpRequired(false);
      setRadioRequired(false);
      setValue([]);
    } else if (radioValue === '') {
      setDrpRequired(true);
      setRadioRequired(false);
    } else if (
      radioValue.trim() === question?.qstn.options[2].values[0].value
    ) {
      setDrpRequired(false);
      setRadioRequired(false);
      setValue([]);
    }
  }, [radioValue]);
  return (
    <React.Fragment>
      <RadioGroup
        label={<strong>{`${question.serial}. ${question.qstn?.questionText}`}</strong>}
        value={radioValue}
        model={`qstn-radio-${question?.qstn?.questionId}`}
        key={`radiogrp-${question?.qstn?.questionId}-${question.serial}`}
        validators={{ required: radioRequired }}
        // eslint-disable-next-line consistent-return
        onChange={(e) => {
          if (
            optionValuesArray.indexOf(e.target.value) >= 0 &&
            focusOnTextBox === false
          ) {
            return setRadioValue(e.target.value);
          }
        }}
      >
        <RadioGroup.Column>
        <SelectInput
          model={`qstn-${question?.qstn?.questionId}`}
          key={`dropdown-${question?.qstn?.questionId}-${question.serial}`}
          isClearable
          value={value}
          hideLabel
          onChange={setValue}
          isSearchable
          options={options}
          validators={{ required: drpRequired }}
        />
        {question.qstn?.options.map((opt, idx) => {
          return idx !== 0 ? (
            <div
              key={`radio-${question?.qstn?.questionId}-${idx}`}
              style={{ marginTop: '8px' }}
            >
              <RadioGroup.Radio
                label={opt.values[0].value}
                value={opt.values[0].value}
                key={opt.id}
              />
              {idx === 1 && radioValue === opt.values[0]?.value ? (
                <TextInput
                  key={`text-${question?.qstn?.questionId}`}
                  model={`text-${question?.qstn?.questionId}`}
                  onFocus={() => {
                    setFocusOnTextBox(true);
                  }}
                  onBlur={() => {
                    setFocusOnTextBox(false);
                  }}
                  isClearable
                  hideLabel
                  validators={{
                    required: 'Please enter at least 4 characters',
                    minLength: {
                      value: 4,
                      message: 'Please enter at least 4 characters',
                    },
                  }}
                />
              ) : null}
            </div>
          ) : (
            ''
          );
        })}
        </RadioGroup.Column>
      </RadioGroup>
    </React.Fragment>
  );
};
